import { FormTypes } from '../../../../components/FormGenerator';
import VenueRegistrationFormModal from '../../shared/VenueRegistrationFormModal';

class BasicInformationVenueSetupDetails extends VenueRegistrationFormModal {
	constructor() {
		super({
			modalSelector: '#venue-setup-details-form-modal',
			triggerSelectors: ['.js-basic-info-add-venue-setup-details', '.js-basic-info-edit-venue-setup-details'],
			stepsEndpointAttr: 'venue-setup-details-steps-endpoint',
			submitEndpointAttr: 'venue-setup-details-submit-endpoint',
			wrapperSelector: '.p-venue-registration-basic-info',
			sectionWrapperSelector: '.p-venue-registration-basic-info-wrapper',
			logPrefix: 'BasicInformationVenueSetupDetails'
		});
	}

	getFormGeneratorOptions() {
		return {
			totalSteps: 1,
			formType: FormTypes.SectionForm,
			exitButtonLabel: 'Save and Exit',
			showExitWithoutSavingButton: true,
			hasSeparator: true,
			exitWithoutSavingButtonLabel: 'Exit without saving',
			exitWithoutSavingButtonHandler: () => this.closeFormModal(),
			submitButton: {
				title: 'Save and continue',
				alwaysVisible: true
			}
		};
	}
}

VenueRegistrationFormModal.boot(BasicInformationVenueSetupDetails);
export default BasicInformationVenueSetupDetails;
